import React from 'react';
import { CustomIcon } from './CustomIcon';
export const Problem = () => {
  return <section id="metodo" className="py-16 bg-gray-50" data-id="element-257">
      <div className="container mx-auto px-4" data-id="element-258">
        <div className="text-center mb-12" data-id="element-259">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-260">
            Conocimiento Oculto Que Debes Saber
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-261">
            Durante años, te repitieron fórmulas financieras que suenan bien en
            EE.UU., pero en Latinoamérica son casi una broma cruel.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-262">
          <div className="bg-white p-8 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-263">
            <div className="bg-red-100 p-4 rounded-full mb-4" data-id="element-264">
              <CustomIcon name="trending-down" size={32} className="text-red-600" data-id="element-265" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-266">
              Precios Inestables
            </h3>
            <p className="text-gray-600" data-id="element-267">
              Aquí los precios suben sin permiso y sin seguir patrones
              predecibles.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-268">
            <div className="bg-red-100 p-4 rounded-full mb-4" data-id="element-269">
              <CustomIcon name="dollar" size={32} className="text-red-600" data-id="element-270" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-271">
              Sueldos Estancados
            </h3>
            <p className="text-gray-600" data-id="element-272">
              Los sueldos no crecen al mismo ritmo que la inflación, creando un
              desequilibrio constante.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-273">
            <div className="bg-red-100 p-4 rounded-full mb-4" data-id="element-274">
              <CustomIcon name="alert" size={32} className="text-red-600" data-id="element-275" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-276">
              Dinero Volátil
            </h3>
            <p className="text-gray-600" data-id="element-277">
              El dinero desaparece sin explicación debido a factores económicos
              únicos de nuestra región.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-278">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-279">
            El Mecanismo Único del Problema:
          </h3>
          <div className="bg-orange-100 p-6 rounded-lg" data-id="element-280">
            <p className="text-lg text-gray-800" data-id="element-281">
              <span className="font-bold" data-id="element-282">
                👉 Usas estrategias diseñadas para otro país.
              </span>{' '}
              Para otra vida. Para otra realidad.
            </p>
          </div>
        </div>
      </div>
    </section>;
};